<!--
 * @Author: zn
 * @Date: 2022-09-28 10:40:05
 * @LastEditors: changfangyuan changfangyuan@sic.com
 * @LastEditTime: 2022-11-18 09:53:21
 * @FilePath: \huangshi_door\src\components\base\table\body\TableImg.vue
-->
<template>
  <div class="app-section_icon" v-loading="loading">
    <div
      class="app-label pointer"
      v-for="(item, index) in tableData"
      :key="index"
      @click="to(item[propers.path], item[propers.id], item[propers.text])"
    >
      <div class="app-icon">
        <el-image fit="cover" :src="item[propers.src]"></el-image>
      </div>
      <div class="app-text">{{ item[propers.text] }}</div>
      <div class="app-tag">{{ item[propers.tag] }}</div>
    </div>
  </div>
</template>
<script>
import { useRoute, useRouter } from "vue-router";

export default {
  name: "TableImg",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
    tableData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    propers: {
      type: Object,
      required: false,
      default() {
        return {
          src: "src",
          text: "text",
          path: "path",
          tag: "tag",
        };
      },
    },
  },

  mounted() {},
  methods: {
    to(path, id, name) {
      if (!path) {
        return this.$messsage.warning("暂未开通");
      }
      this.$router.push({ path: path, query: { policyId: id, name: name } });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "@/styles/public/variable";
// @import "@/styles/public/mixin";


.app-section_icon {
  display: flex;
  flex-wrap: wrap !important;
  justify-content: space-between;
  .app-label {
    border: 1px solid #f2f2f2;
    /*box-shadow: 0 3px 6px rgba(149, 197, 254, 16%);*/
    // flex: 1;
    width: 24%;
    height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-left: 1%;
    .app-text{
      line-height: 1;
      margin-top: 10px;
      font-size: 18px;
      font-family: $fontFamily;
      position: absolute;
      top: 14%;
      left: 20px;
      font-weight: bold;
    }
    .app-tag {
      margin-top: 10px;
      font-size: 14px;
    }
    &:hover{
      border-color: #70abee;
    }
    &:first-child{
      margin-left: 0;
    }
  }
}
.app-icon,
.el-image {
  width: 100%;
  height: 100%;
}
</style>
